import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import * as Highcharts from 'highcharts';
import {Options} from 'highcharts';
import moment from 'moment-timezone';
import {InsightsService} from "../../services/insights/insights.service";
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {TrendChartService} from "../../services/trend-chart/trend-chart.service";

@Component({
  selector: 'app-nps-trend',
  templateUrl: './nps-trend.component.pug',
  styleUrls: ['./nps-trend.component.scss'],
  standalone: false
})
export class NpsTrendComponent implements OnInit, OnChanges {

  @Input() start!: any;
  @Input() end!: any;
  @Input() questionnaire!: any;
  @Input() filterBy!: any;
  @Input() pause_load = false;
  updateFlag = false;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Options = TrendChartService.getOptions([], -100, 100, 230, 800, '#FFF', 'rgb(50,115,95)', 'rgb(255, 255, 255)', '#32735F', 'quarters');

  constructor(private insightsService: InsightsService,
              private alertList: AlertBannerService,) {
  }

  ngOnInit(): void {
  }

  private loadAndSetData() {
    if(this.pause_load) {
      return;
    }
    this.insightsService.getNPSTrend(this.start, this.end, this.questionnaire, this.filterBy).subscribe(data => {
      let series: any = [];
      for (let d of data) {
        series.push([moment.utc(d['date'], 'YYYY_Q').toDate().getTime(), d['nps']]);
      }
      TrendChartService.setChartOptionsFromData(this.chartOptions, series, 'quarters');
      this.updateFlag = true;
    }, error => {
      console.log(error);
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
      TrendChartService.setChartOptionsFromData(this.chartOptions, [], 'quarters');
      this.updateFlag = true;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.loadAndSetData();
  }
}
